module.exports = __webpack_public_path__ + "img/tziyur_yes.950753ab.png";